import React, { useEffect, useState } from 'react';
import * as FuncionesPartidos from '../../funciones/FuncionesPartidos.js';
import styles from './ElegirFechaEtapa.module.css';

const ElegirFechaEtapa = (props) => {
  const etapa = props.etapa;
  const fechaElegida = props.fechaElegida;
  const [fechas, setFechas] = useState([]);

  useEffect(() => {
    // Generar fechas desde 1 hasta cantidadFechas
    if (etapa && etapa.cantidadFechas) {
      const nuevasFechas = [];
      for (let i = 1; i <= etapa.cantidadFechas; i++) {
        nuevasFechas.push(i);
      }
      setFechas(nuevasFechas);
    } else {
      setFechas([]);
    }
  }, [etapa]);

  useEffect(() => {
    // Seleccionar la primera fecha automáticamente
    if (fechas.length > 0 && !fechaElegida) {
      props.onFechaElegida(fechas[0]);
    }
  }, [fechas, fechaElegida, props]);

  const fechaElegidaHandler = (event) => {
    props.onFechaElegida(Number(event.target.id));
  };

  return (
    <div className={`${styles.contenedor}`}>
      <div className={`${styles.titulo}`}>Fecha</div>
      <div className={`${styles.listaFechas}`}>
        {fechas.map((fecha) => (
          <button
            className={`${styles.selectorFecha} ${
              fechaElegida && Number(fechaElegida) === Number(fecha) ? styles.elegido : ''
            }`}
            key={fecha}
            id={fecha}
            onClick={fechaElegidaHandler}
          >
            {FuncionesPartidos.DetalleFecha(fecha, null)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ElegirFechaEtapa;
